import { Loader2, Pencil, Trash2 } from 'lucide-react'
import { Button } from '~/components/ui/button'
import type { MonitoringReading } from '~/api/types'

export interface ReadingRowProps {
    r: MonitoringReading
    labels: Record<string, string>
    batchLabels?: Record<string, string>
    editId: string | null
    setEditId(id: string | null): void
    editValue: string
    setEditValue(value: string): void
    busyId: string | null
    startEdit(r: MonitoringReading): void
    saveEdit(r: MonitoringReading): void
    remove(r: MonitoringReading): void
}

/** 적재된 측정값 1행 — 값 인라인 수정·삭제(CRUD). */
export function ReadingRow({
    r,
    labels,
    batchLabels,
    editId,
    setEditId,
    editValue,
    setEditValue,
    busyId,
    startEdit,
    saveEdit,
    remove,
}: ReadingRowProps) {
    const batchLabel =
        r.batchId && batchLabels?.[r.batchId] ? batchLabels[r.batchId] : null
    return (
        <tr className='border-border border-b last:border-0'>
            <td className='text-muted-foreground py-2 pr-3 text-xs'>
                {r.measuredAt?.slice(0, 16)}
            </td>
            <td className='text-foreground py-2 pr-3'>
                {labels[r.fieldId] ?? r.fieldId}
            </td>
            <td className='py-2 pr-3'>
                {editId === r.id ? (
                    <input
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                        className='border-border bg-card text-foreground h-8 w-28 rounded-md border px-2 text-sm'
                    />
                ) : (
                    <>
                        {r.value}
                        {r.unit ? ` ${r.unit}` : ''}
                    </>
                )}
            </td>
            <td className='text-muted-foreground py-2 pr-3 text-xs'>
                <span className='flex items-center gap-1'>
                    <span className='shrink-0'>{r.source}</span>
                    {batchLabel ? (
                        <span className='text-muted-foreground/70 max-w-40 truncate'>
                            · {batchLabel}
                        </span>
                    ) : null}
                </span>
            </td>
            <td className='py-2'>
                <div className='flex gap-1'>
                    {editId === r.id ? (
                        <>
                            <Button
                                size='sm'
                                disabled={busyId === r.id}
                                onClick={() => saveEdit(r)}>
                                {busyId === r.id ? (
                                    <Loader2 className='animate-spin' />
                                ) : null}
                                저장
                            </Button>
                            <Button
                                size='sm'
                                variant='outline'
                                onClick={() => setEditId(null)}>
                                취소
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button
                                size='sm'
                                variant='outline'
                                onClick={() => startEdit(r)}>
                                <Pencil />
                                수정
                            </Button>
                            <Button
                                size='sm'
                                variant='outline'
                                disabled={busyId === r.id}
                                onClick={() => remove(r)}>
                                <Trash2 />
                                삭제
                            </Button>
                        </>
                    )}
                </div>
            </td>
        </tr>
    )
}
